import {createActionGroup, emptyProps, props} from "@ngrx/store";
import {FundValuationSensitivityOverview} from "../../models/fund-valuation-sensitivity-overview";
import {FundValuationSensitivity} from "../../models/fund-valuation-sensitivity";
import {ComputeSensitivitiesRequest} from "../../generated-sources/api";

export const FvSensitivityActions = createActionGroup({
    source: "Sensitivity Actions",
    events: {
        load: props<{ fundId: number, fundValuationId: number }>(),
        loadSuccess: props<{ fundValuationSensitivityOverview: FundValuationSensitivityOverview }>(),
        loadError: props<{ errorMsg: string }>(),

        compute: props<{
            fundId: number;
            fundValuationId: number;
            paramType: ComputeSensitivitiesRequest.ParamTypeEnum;
            step: number;
            steps: number;
        }>(),
        computeSuccess: props<{ fundValuationSensitivityOverview: FundValuationSensitivityOverview }>(),
        computeError: props<{ errorMsg: string }>(),

        setColumnTokens: props<{ tokens: string[] }>(),

        clearState: emptyProps()
    }
});

export const FvSensitivityDetailsActions = createActionGroup({
    source: "Sensitivity Details Actions",
    events: {
        load: props<{ fundId: number, fundValuationId: number, fundValuationSensitivityId: number }>(),
        loadSuccess: props<{ fundValuationSensitivity: FundValuationSensitivity }>(),
        loadError: props<{ errorMsg: string }>()
    }
});
